import React, { useContext, useEffect, useState } from "react";
import { Navbar, Nav, Dropdown } from "react-bootstrap";
import { useLocation, useNavigate } from "react-router-dom";
import { BsThreeDotsVertical } from "react-icons/bs";
import userIcon from "./../../Assets/icons/profile.svg";
import EwentLogo from "./../../Assets/icons/E-wentPNG.png";
import rectangleLogo from "./../../Assets/icons/logo-newtron-green.svg";
import "./index.scss";
import { useAuth } from "../../context/AuthContext";
import { RxCross1 } from "react-icons/rx";
import {
  MdOutlineKeyboardArrowDown,
  MdKeyboardArrowRight,
} from "react-icons/md";
import GlobalContext from "../../context/GlobalContext"; 
import { versionNumber } from "../../constants/version";

const HeaderNavbar = ({ isLoginPage, menuData }) => {
  // const {profileImg} = useContext(GlobalContext)
  // const { profileImg } = useContext(GlobalContext);
  console.log(menuData, "menuDataHeaderValue");
  const navigate = useNavigate();
  const location = useLocation();
  const {
    email,
    logout,
    isLoggedIn
    //  profileImg
  } = useAuth();
  // const isLoggedIn = location?.state;
  // console.log("isloggedin>>", isLoggedIn);
  const dealerUsername = localStorage.getItem("UserName");
  const business_partner_id = localStorage.getItem("business_partner_id");
  const profileImage = localStorage.getItem("profileImage");
  const authToken = sessionStorage.getItem("u_t");
  // business_partner_id

  const [showSidebar, setShowSidebar] = useState(false);
  const [expandedMenus, setExpandedMenus] = useState({});

  const toggleSubmenu = (parentId) => {
    setExpandedMenus((prev) => ({
      ...prev,
      [parentId]: !prev[parentId],
    }));
  };

  const handleLogout = () => {
    // localStorage.removeItem('authToken');

    // navigate('/');
    logout();
  };

  // useEffect(() => {
  //   const handleTabClose = () => {
  //     handleLogout();
  //   };

  //   window.addEventListener("beforeunload", handleTabClose);

  //   return () => {
  //     window.removeEventListener("beforeunload", handleTabClose);
  //   };
  // }, []);

  const getNameFromEmail = (email) => {
    if (email) {
      return email.split("@")[0];
    }
    return "";
  };
  const userName = getNameFromEmail(email);

  const toggleSidebar = () => {
    setShowSidebar(!showSidebar);
  };

  const handleNavigation = (url) => {
    navigate(`/${url}`);
    setShowSidebar(!showSidebar);
  };

  const navigateToViewProfileDealer = () => {
    navigate("/dealer-edit/view-profile");
  };

  return (
    <>
      {email && (
        <Navbar bg="white" variant="white" expand="lg">
          <div className="headernavContainer">
            <Navbar.Brand className="headerLogo">
              <img
                src={rectangleLogo}
                alt="DmsEwentLogo"
                style={{ height: "56px", width: "110px", objectFit: "contain" }}
              />
            </Navbar.Brand>
            {/* <h4 style={{ margin: "0 20px", fontWeight: 500 }}>
              Welcome <span style={{ color: "black" }}>{dealerUsername}</span>
            </h4> */}
            <h4 style={{ margin: "0 20px", fontWeight: 500 }}>
              Welcome{" "}
              {dealerUsername && (
                <span style={{ color: "black" }}>
                  {dealerUsername.replace(/null/gi, "").trim()}
                </span>
              )} {versionNumber && <span style={{ color: "gray", fontSize: "14px" }}>{versionNumber}</span>}
            </h4>

            <div
              className="ms-auto"
              style={{
                display: "flex",
                flexDirection: "row",
                alignItems: "center",
                justifyContent: "center",
                gap: "5px",
              }}
            >
              {/* <Dropdown className="toggleExplandDropdown">
                <Dropdown.Toggle
                  className="toggleCollapse"
                  variant="light"
                  id="dropdown-basic"
                >
                  <img src={userIcon} alt="User" width="30" height="30" />
                </Dropdown.Toggle>
                <Dropdown.Menu align="end">
                  <Dropdown.Item>{userName}</Dropdown.Item>
                  <Dropdown.Item onClick={logout}>Logout</Dropdown.Item>
                </Dropdown.Menu>
              </Dropdown> */}
              <div>
                {!isLoginPage && (
                  <div
                    className="settingMenuLogo"
                    onClick={toggleSidebar}
                    style={{ cursor: "pointer" }}
                  >
                    <BsThreeDotsVertical size={25} />
                  </div>
                )}
              </div>

              <Navbar.Collapse id="basic-navbar-nav">
                <Nav className="me-auto"></Nav>

                <Nav>
                  {email && (
                    <Dropdown>
                      <Dropdown.Toggle variant="light" id="dropdown-basic">
                        <img
                          src={
                            profileImage &&
                            profileImage !== "null" &&
                            profileImage !== ""
                              ? profileImage
                              : userIcon
                          }
                          // src={profileImg && profileImg !== "null" && profileImg !== "" ? profileImg : userIcon}
                          alt="User"
                          width="40"
                          height="40"
                        />{" "}
                        {/* {
                          profileImage === null ? (
                            <>
                            <img src={userIcon} alt="User" width="40" height="40" />{" "}
                            </>
                          ) : (
                            <>
                            <img
                          src={profileImage}
                          alt="Saraogi"
                          width="40"
                          height="40"
                          style={{ borderRadius: "50%", paddingRight:"8px" }}
                        />
                            </>
                          )
                        } */}
                        {userName}
                      </Dropdown.Toggle>

                      <Dropdown.Menu align="end">
                        {business_partner_id <= 0 && (
                          <Dropdown.Item onClick={navigateToViewProfileDealer}>
                            View Profile
                          </Dropdown.Item>
                        )}
                        {/* <Dropdown.Item onClick={navigateToViewProfileDealer} >View Profile</Dropdown.Item> */}
                        <Dropdown.Item onClick={logout}>Logout</Dropdown.Item>
                      </Dropdown.Menu>
                    </Dropdown>
                  )}
                </Nav>
              </Navbar.Collapse>
            </div>
          </div>
        </Navbar>
      )}

      {/* Sidebar */}
      {showSidebar && (
        <div className="sidebarMobile">
          <div className="sidebar-header">
            <div>
              <img
                src={rectangleLogo}
                alt="DmsEwentLogo"
                style={{
                  height: "56px",
                  width: "110px",
                  objectFit: "contain",
                }}
              />
            </div>
            <button className="close-sidebar" onClick={toggleSidebar}>
              <RxCross1 />
            </button>
          </div>
          <div
            style={{ fontSize: "26px", padding: "18px 6px 0px 18px" }}
            onClick={() => navigate("/cards")}
            className="ParentTitle"
          >
            {menuData[0]?.parentTitle}
          </div>
          <div className="sidebar-content">
            {menuData?.map((item) => (
              <div
                key={item.parentId}
                style={{
                  display: "flex",
                  justifyContent: "flex-start",
                  alignItems: "flex-start",
                }}
                className="sidebar-item"
              >
                <div
                  style={{ padding: "5px 10px", borderRadius: "10px" }}
                  className="leftmenuiconcontainer"
                >
                  <img
                    src={item.parentMenuIcon}
                    alt={item.parentMenuName}
                    className=".menu-icon"
                  />
                </div>
                {/* <span
            onClick={() => handleNavigation(item.parentUrl)}
            className="menu-link"
            style={{ cursor: "pointer", textDecoration: "none", color: "#fff" }}
          >
            {item.parentMenuName}
          </span> */}
                <div style={{ marginTop: "10px" }}>
                  <div style={{ display: "flex", gap: "10px" }}>
                    <span
                      onClick={() => {
                        if (!item.children || item.children.length === 0) {
                          handleNavigation(item.parentUrl);
                        }
                      }}
                      className="menu-link"
                      style={{
                        cursor:
                          item.children && item.children.length > 0
                            ? "default"
                            : "pointer",
                        textDecoration: "none",
                        color: "#fff",
                      }}
                    >
                      {item.parentMenuName}
                    </span>

                    {/* Submenu toggle button */}
                    <div>
                      {item.children && item.children.length > 0 && (
                        <button
                          className="submenu-toggle"
                          onClick={() => toggleSubmenu(item.parentId)}
                          style={{
                            background: "none",
                            border: "none",
                            cursor: "pointer",
                            fontSize: "20px",
                          }}
                        >
                          {expandedMenus[item.parentId] ? (
                            <MdOutlineKeyboardArrowDown
                              style={{ color: "white" }}
                            />
                          ) : (
                            <MdKeyboardArrowRight style={{ color: "white" }} />
                          )}
                        </button>
                      )}
                    </div>
                  </div>

                  {/* Render children when expanded */}
                  <div>
                    {expandedMenus[item.parentId] &&
                      item.children &&
                      item.children.length > 0 && (
                        <div className="submenu">
                          {item.children.map((child) => (
                            <div key={child.childId} className="submenu-item">
                              <span
                                onClick={() => handleNavigation(child.childUrl)}
                                style={{
                                  cursor: "pointer",
                                  color: "#ddd",
                                  paddingLeft: "20px",
                                }}
                              >
                                {child.childMenuName}
                              </span>
                            </div>
                          ))}
                        </div>
                      )}
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      )}
    </>
  );
};

export default HeaderNavbar;
